import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncUploadDocument = loadable(() => import('./UploadDocument'), {
  fallback: <Loader />,
});
